
export enum PermissionEnum {
    view_dashboard = "dashboard",
    manage_users = "users",
    users_table = "users",
    deposit_table = "transactions",
    transfer_table = "transactions",
    currencies = "currencies",
    sanctions_table = "compliance",
    exchange_rate = "exchange_rates",
    beneficiaries = "beneficiaries",
    charity_table = "charity",
    audit_trail = "audit_trail"
}